module.exports = __webpack_public_path__ + "img/icon-01.af18434c.png";